import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/globals.css";

const BOOTSTRAP_RELOAD_KEY = "admin:bootstrap-reload";

async function loadTenantConfig() {
  await new Promise<void>((resolve) => {
    const script = document.createElement("script");
    script.src = "/tenant.config.js";
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => resolve();
    document.head.appendChild(script);
  });

  const tenant = window.__TENANT || {};
  document.title = `Admin | ${tenant.brandName || "Backoffice"}`;

  const favicon = document.getElementById("adminFavicon") as HTMLLinkElement | null;
  if (favicon && tenant.faviconUrl) {
    favicon.href = tenant.faviconUrl;
  }
}

async function bootstrap() {
  try {
    await loadTenantConfig();

    const [{ QueryClientProvider }, { RouterProvider }, { queryClient }, { router }] =
      await Promise.all([
        import("@tanstack/react-query"),
        import("react-router-dom"),
        import("./lib/queryClient"),
        import("./app/router"),
      ]);

    sessionStorage.removeItem(BOOTSTRAP_RELOAD_KEY);

    ReactDOM.createRoot(document.getElementById("root")!).render(
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </React.StrictMode>,
    );
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    const isChunkError =
      message.includes("Failed to fetch dynamically imported module")
      || message.includes("Importing a module script failed")
      || message.includes("Loading chunk");

    if (isChunkError && sessionStorage.getItem(BOOTSTRAP_RELOAD_KEY) !== "1") {
      sessionStorage.setItem(BOOTSTRAP_RELOAD_KEY, "1");
      window.location.reload();
      return;
    }

    throw error;
  }
}

void bootstrap();
